module.exports = __webpack_public_path__ + "img/877-a18a2c.png";